import { Link, useNavigate } from "react-router-dom";
import { useMe } from "../lib/api";
import { logout } from "../lib/auth-actions";
import { useAuthStore } from "../lib/auth-store";
import { Avatar } from "./Avatar";

const navPill =
  "rounded-full border border-slate-700/60 bg-slate-900/40 px-3 py-1.5 text-slate-300 transition hover:border-cyan-400/50 hover:text-cyan-200";
const ctaPill = "btn-neon rounded-full px-3 py-1.5 text-sm font-medium";

export function Header() {
  const fbUser = useAuthStore((s) => s.fbUser);
  const { data: me } = useMe(Boolean(fbUser));
  const navigate = useNavigate();

  return (
    <>
      <header className="sticky top-0 z-40 border-b border-cyan-400/20 glass">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Link to="/" className="flex flex-col leading-none">
            <span className="font-mono text-[10px] tracking-[0.3em] text-cyan-400/70">
              {"// CLASSFIRE"}
            </span>
            <span className="neon-text text-lg font-bold">PROJECT SHARE</span>
          </Link>
          <nav className="flex flex-wrap items-center justify-end gap-2 text-sm">
            <Link to="/" className={navPill}>
              HOME
            </Link>
            {fbUser ? (
              <>
                <Link to="/projects/new" className={ctaPill}>
                  새 프로젝트
                </Link>
                {me?.role === "admin" && (
                  <Link to="/admin/users" className={navPill}>
                    관리자
                  </Link>
                )}
                <Link
                  to="/profile"
                  className="flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/5 py-1 pr-3 pl-1 text-cyan-200 transition hover:border-cyan-300/60 hover:text-cyan-100"
                >
                  <Avatar avatarUrl={me?.avatarUrl} nickname={me?.nickname ?? "?"} size={26} />
                  {me?.nickname ?? "..."}
                </Link>
                <button
                  type="button"
                  onClick={async () => {
                    await logout();
                    navigate("/login");
                  }}
                  className="rounded-full border border-slate-700/60 bg-slate-900/40 px-3 py-1.5 text-slate-400 transition hover:border-fuchsia-400/50 hover:text-fuchsia-300"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <Link to="/login" className={ctaPill}>
                로그인
              </Link>
            )}
          </nav>
        </div>
      </header>
      {fbUser && me && !me.emailVerified && (
        <div className="bg-fuchsia-500/10 py-2 text-center text-xs text-fuchsia-300">
          이메일 인증이 필요합니다.{" "}
          <Link to="/verify-email" className="underline hover:text-fuchsia-200">
            인증하기
          </Link>
        </div>
      )}
    </>
  );
}
